<script setup lang="ts">
    import { IInteraction } from '@/js/services/api/interaction/types';
    import { __ } from '@/js/stores/expressions';
    import { ref, watch } from 'vue';

    const props = defineProps<{
        interaction?: IInteraction;
        containerRef: HTMLElement | null;
    }>();

    const width = ref(0);

    watch(
        () => props.containerRef,
        (newVal) => {
            if (newVal) {
                width.value = newVal.clientWidth - 24;
            }
        },
        { immediate: true }
    );
</script>

<template>
    <div class="flex relative">
        <div
            :style="{ width: width + 'px' }"
            class="w-full sticky top-0 left-3 border-1 border-gray-lightest rounded-lg p-3"
        >
            <div
                v-if="props.interaction?.summary"
                class="grid grid-cols-2 gap-x-8 gap-y-6 rounded-md bg-primary-plum-50 px-8 py-8"
            >
                <div class="min-w-0">
                    <h2 class="text-overline-sm text-gray-dark">
                        {{ __('interactions-summary') }}
                    </h2>
                    <p class="text-body whitespace-normal break-words leading-5">
                        {{ props.interaction.summary.summary ?? __('interactions-no-data') }}
                    </p>
                </div>

                <div class="min-w-0">
                    <h2 class="text-overline-sm text-gray-dark">
                        {{ __('interactions-contact-reason') }}
                    </h2>
                    <p class="text-body whitespace-normal break-words leading-5">
                        {{
                            props.interaction.summary.reasonForContact ?? __('interactions-no-data')
                        }}
                    </p>
                </div>

                <div class="min-w-0">
                    <h2 class="text-overline-sm text-gray-dark">
                        {{ __('interactions-solution') }}
                    </h2>
                    <p class="text-body whitespace-normal break-words leading-5">
                        {{ props.interaction.summary.solution ?? __('interactions-no-data') }}
                    </p>
                </div>

                <div class="min-w-0">
                    <h2 class="text-overline-sm text-gray-dark">
                        {{ __('interactions-solved') }}
                    </h2>
                    <p class="text-body whitespace-normal break-words leading-5">
                        {{ props.interaction.summary.solved === 'Y' ? __('yes') : __('no') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
